import script from "./BrandDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./BrandDashboard.vue?vue&type=style&index=0&id=477eacdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477eacdc"]])

export default __exports__